// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  padding: 0;
  margin: 0;
}

:root {
  --left-sidebar-width: 320px;
  --right-sidebar-width: 0;
  --header-height: 0;
  --nav-toggle-items-height: 0;
  --banner-height: 0;
}

#newron {
  display: grid;
  grid-template-areas: 'head' 'content';
  grid-template-columns: 1fr;
  grid-template-rows: var(--header-height) 1fr;
  min-height: 100vh;
  margin-top: var(--banner-height);
}

#newron-left-sidebar {
  position: fixed;
  top: var(--banner-height);
  left: 0;
  bottom: 0;
  width: var(--left-sidebar-width);
  z-index: 100;
  height: -webkit-fill-available;
}

#newron-right-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: var(--right-sidebar-width);
  z-index: 100;
}

#newron-header {
  transition: width 0.25s ease-in-out, margin 0.25s ease-in-out;
  width: calc(100vw - var(--left-sidebar-width) - var(--right-sidebar-width));
  margin-left: var(--left-sidebar-width);
  margin-right: var(--right-sidebar-width);
  grid-area: head;
}

#newron-content {
  transition: width 0.25s ease-in-out, margin 0.25s ease-in-out;
  width: calc(100vw - var(--left-sidebar-width) - var(--right-sidebar-width));
  margin-left: var(--left-sidebar-width);
  margin-right: var(--right-sidebar-width);
  grid-area: content;
}

#newron-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: auto;
  z-index: 100;
}

#QSIFeedbackButton-target-container {
  z-index: 91 !important;
}

.SI_2lR1h53Puz3l0Oi_SliderContainer {
  z-index: 91 !important;
}
.QSIFeedbackButton {
  z-index: 90 !important;
}

#apt-widget-controller {
  z-index: 90 !important;
}

#QSIFeedbackButton-overlay-container {
  height: 90% !important;
  width: 760px !important;
}

#QSIFeedbackButton-close-btn {
  margin-bottom: -93px;
  margin-right: 21px;
  outline: 0 none !important;
  background: url('https://experience.nielseniq.com/ControlPanel/Graphic.php?IM=IM_4GgDCqAolHx8Kep') center / contain
    no-repeat;
  width: 17px;
}

#QSIFeedbackButton-close-btn:focus {
  box-shadow: none;
}

#QSIFeedbackButton-close-btn img {
  display: none;
}

#QSIFeedbackButton-btn {
  width: 62px !important;
  height: 70px !important;
}

#QSIFeedbackButton-btn > img {
  width: 62px !important;
  height: 70px !important;
}

#QSIFeedbackButton-btn > div {
  padding: 10px 7px 10px 10px !important;
}

#QSIFeedbackButton-btn * {
  font-size: 18px !important;
}
.SI_2lR1h53Puz3l0Oi_SliderContainer > div:nth-of-type(2) {
  border: 1px solid #bbc0c9 !important;
  background-color: #fff !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 2px 0 #0000001a;
}
.SI_2lR1h53Puz3l0Oi_SliderContainer > div:nth-of-type(3) {
  border-radius: 8px !important;
}
.SI_2lR1h53Puz3l0Oi_SliderContainer > div:nth-of-type(3) > div {
  border-radius: 8px;
}

@media screen and (max-width: 1200px) {
  .mobile #newron-header {
    margin-right: 0px;
    margin-left: 0px;
    width: 100vw;
    min-height: 60px;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .mobile#newron {
    grid-template-rows: 1fr;
  }
  .mobile #newron-header-content > div > div:last-child {
    gap: 8px;
  }
  .mobile #newron-content {
    margin-right: 0px;
    width: 100vw;
    margin-left: 0px;
  }
  #QSIFeedbackButton-btn {
    display: none !important;
  }
  .mobile-impersonate .flex-column {
    max-width: 100vw;
  }
  .mobile .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 50;
    background-color: #6f7582;
    opacity: 0.4;
  }
  .mobile .z-90 {
    z-index: 90;
  }
  .mobile {
    --left-sidebar-width: 255px;
    --header-height: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/main.css"],"names":[],"mappings":"AAAA;;EAEE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,4CAA4C;EAC5C,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,OAAO;EACP,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2EAA2E;EAC3E,sCAAsC;EACtC,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,2EAA2E;EAC3E,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B;aACW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;AACF","sourcesContent":["html,\nbody {\n  padding: 0;\n  margin: 0;\n}\n\n:root {\n  --left-sidebar-width: 320px;\n  --right-sidebar-width: 0;\n  --header-height: 0;\n  --nav-toggle-items-height: 0;\n  --banner-height: 0;\n}\n\n#newron {\n  display: grid;\n  grid-template-areas: 'head' 'content';\n  grid-template-columns: 1fr;\n  grid-template-rows: var(--header-height) 1fr;\n  min-height: 100vh;\n  margin-top: var(--banner-height);\n}\n\n#newron-left-sidebar {\n  position: fixed;\n  top: var(--banner-height);\n  left: 0;\n  bottom: 0;\n  width: var(--left-sidebar-width);\n  z-index: 100;\n  height: -webkit-fill-available;\n}\n\n#newron-right-sidebar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: var(--right-sidebar-width);\n  z-index: 100;\n}\n\n#newron-header {\n  transition: width 0.25s ease-in-out, margin 0.25s ease-in-out;\n  width: calc(100vw - var(--left-sidebar-width) - var(--right-sidebar-width));\n  margin-left: var(--left-sidebar-width);\n  margin-right: var(--right-sidebar-width);\n  grid-area: head;\n}\n\n#newron-content {\n  transition: width 0.25s ease-in-out, margin 0.25s ease-in-out;\n  width: calc(100vw - var(--left-sidebar-width) - var(--right-sidebar-width));\n  margin-left: var(--left-sidebar-width);\n  margin-right: var(--right-sidebar-width);\n  grid-area: content;\n}\n\n#newron-banner {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: auto;\n  z-index: 100;\n}\n\n#QSIFeedbackButton-target-container {\n  z-index: 91 !important;\n}\n\n.SI_2lR1h53Puz3l0Oi_SliderContainer {\n  z-index: 91 !important;\n}\n.QSIFeedbackButton {\n  z-index: 90 !important;\n}\n\n#apt-widget-controller {\n  z-index: 90 !important;\n}\n\n#QSIFeedbackButton-overlay-container {\n  height: 90% !important;\n  width: 760px !important;\n}\n\n#QSIFeedbackButton-close-btn {\n  margin-bottom: -93px;\n  margin-right: 21px;\n  outline: 0 none !important;\n  background: url('https://experience.nielseniq.com/ControlPanel/Graphic.php?IM=IM_4GgDCqAolHx8Kep') center / contain\n    no-repeat;\n  width: 17px;\n}\n\n#QSIFeedbackButton-close-btn:focus {\n  box-shadow: none;\n}\n\n#QSIFeedbackButton-close-btn img {\n  display: none;\n}\n\n#QSIFeedbackButton-btn {\n  width: 62px !important;\n  height: 70px !important;\n}\n\n#QSIFeedbackButton-btn > img {\n  width: 62px !important;\n  height: 70px !important;\n}\n\n#QSIFeedbackButton-btn > div {\n  padding: 10px 7px 10px 10px !important;\n}\n\n#QSIFeedbackButton-btn * {\n  font-size: 18px !important;\n}\n.SI_2lR1h53Puz3l0Oi_SliderContainer > div:nth-of-type(2) {\n  border: 1px solid #bbc0c9 !important;\n  background-color: #fff !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 2px 0 #0000001a;\n}\n.SI_2lR1h53Puz3l0Oi_SliderContainer > div:nth-of-type(3) {\n  border-radius: 8px !important;\n}\n.SI_2lR1h53Puz3l0Oi_SliderContainer > div:nth-of-type(3) > div {\n  border-radius: 8px;\n}\n\n@media screen and (max-width: 1200px) {\n  .mobile #newron-header {\n    margin-right: 0px;\n    margin-left: 0px;\n    width: 100vw;\n    min-height: 60px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n  .mobile#newron {\n    grid-template-rows: 1fr;\n  }\n  .mobile #newron-header-content > div > div:last-child {\n    gap: 8px;\n  }\n  .mobile #newron-content {\n    margin-right: 0px;\n    width: 100vw;\n    margin-left: 0px;\n  }\n  #QSIFeedbackButton-btn {\n    display: none !important;\n  }\n  .mobile-impersonate .flex-column {\n    max-width: 100vw;\n  }\n  .mobile .overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 50;\n    background-color: #6f7582;\n    opacity: 0.4;\n  }\n  .mobile .z-90 {\n    z-index: 90;\n  }\n  .mobile {\n    --left-sidebar-width: 255px;\n    --header-height: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
